<!--
  OrderFormModal: alta y edición de pedidos.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      add()        Abre el alta vacía.
      edit(item)   Abre la edición. item: pedido de la API; el detalle se busca con mostrarPedido(item.id).
      close()      Cierra el modal sin confirmar.

  SALIDA
    Eventos:
      @saved(response)   Se guardó. La vista recarga lo que corresponda.
    Efectos:
      Alta y edición por agregarPedido y editarPedido.
      EN EL BACKEND, según la configuración de pedidos: valida stock y lo descuenta al generar
      (m_orders_configurations id 24 y id 3). Puede notificar por email al cliente.

  USOS
    Vista: <OrderFormModal ref="orderForm" @saved="filterOrders()" />
    Alta:     this.$refs.orderForm.add()
    Edición:  this.$refs.orderForm.edit(item)
    Hoy se invoca desde orders/staff/crudOrders.vue: botón, dropdown y drawer, y ?new=1 de la paleta de comandos.

  DEPENDENCIAS Y PERMISOS
    Parámetros: P52 (ítems duplicados), P54 (motivos), P75 (total con IVA por precio final).
    Configuración de pedidos: la consulta por su cuenta con obtenerConfiguracion(), al montarse y al volver a la pestaña.
    Componentes: FindObject, cpbtDetail/detailProducts.
    No controla permisos: quien lo invoca decide si el usuario puede abrirlo.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            size="xl"
            dialog-class="orders-form-modal-dialog"
            :key="modal.form._id"
            :id="modal.form._id">
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <form-wizard  title=""
                    subtitle=""
                    nextButtonText="Siguiente"
                    backButtonText="Atrás"
                    finishButtonText="Guardar"
                    color="#2f353a"
                    shape="tab"
                    @on-complete="save"
                    class="crud-orders-wizard">

        <tab-content title="General" icon="fa fa-edit" :before-change="orderValidDetailGeneral">
          <b-row>
            <b-col md="4">
              <FindObject render="search"
                          type="customers"
                          @select-object="loadCustomers($event)"
                          :valueID="crud.form.customers_id"
                          :where="conditionCustomersActive"
                          :disabled="crud.form.id>0"/>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <FindObject render="search"
                          type="erpPointsSales"
                          auto-select-single
                          display="full_identification"
                          @select-object="loadPointsSales($event)"
                          :valueID="crud.form.erp_points_sales_id"
                          :key="crud.form.erp_points_sales_id"
                          :showAllRegister="true"
                          :where="conditionPointsSalesActive" />
            </b-col>
            <b-col md="4">
              <FindObject render="search"
                          type="erpMethodsPayment"
                          auto-select-single
                          @select-object="loadMethodsPayment($event)"
                          :valueID="crud.form.methods_payment_id"
                          :key="crud.form.methods_payment_id" />
            </b-col>
            <b-col md="4">
              <FindObject render="search"
                          type="priceList"
                          @select-object="loadPriceList($event)"
                          :valueID="crud.form.price_list_id"
                          :key="crud.form.price_list_id"
                          :where="conditionPriceListActive"
                          :disabled="crud.form.id>0" />
            </b-col>
            <b-col md="4" v-if="showShipping">
              <FindObject render="search"
                          type="suppliers"
                          @select-object="loadShipping($event)"
                          :where="conditionSuppliersShippingActive"
                          :valueID="crud.form.shipping_id"
                          tag="Transporte"
                          :key="crud.form.shipping_id"/>
            </b-col>

            <b-col md="4" v-if="parameters.haveReason">
              <FindObject render="search"
                          type="orders-reason"
                          @select-object="loadReason($event)"
                          :valueID="crud.form.reason_id"
                          tag="Motivos"
                          :key="crud.form.reason_id"
                          :where="conditionReason"
                          :disabled="crud.form.id>0" />
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Productos" icon="fa fa-qrcode" :before-change="orderValidDetailItems">
          <b-row>
            <b-col lg="12" md="12" sm="12">
                <Detail ref="orderDetail"
                        :customer_id="crud.form.customers_id"
                        :price_list_id="crud.form.price_list_id"
                        :reason_id="crud.form.reason_id"
                        :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                        @load-detail="crud.form.detail = $event"
                        :editPrice="editPrice"
                        :validStock="validStock"
                        :detailEdit="crud.form.detail"
                        :showDiscount="false"
                        :key="'detailOrder_'+itemDetailForceUpdate"
                        :forceUpdate="itemDetailForceUpdate"
                        :validItemDuplicated="!allowProductsDuplicates"
                        :getItemOnlyPublished="showItemOnlyPublished" />

                <b-row class="pl-3 pr-3 pb-2 mt-2">
                  <b-col md="2" class="mb-2 mb-md-0">
                    <div class="crud-orders-stat">
                      <span class="crud-orders-stat__label">Items</span>
                      <span class="crud-orders-stat__value">{{this.getCantItemOrder}}</span>
                    </div>
                  </b-col>
                  <b-col md="6"></b-col>
                  <b-col md="4" v-if="getCurrencyOrder">
                    <div class="crud-orders-totals">
                      <div class="crud-orders-totals__row">
                        <span class="crud-orders-totals__label">Subtotal</span>
                        <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getSubTotalOrder)}}</span>
                      </div>
                      <div class="crud-orders-totals__row">
                        <span class="crud-orders-totals__label">{{ this.getTagDiscount }}</span>
                        <div class="crud-orders-totals__discount-group">
                          <div class="crud-orders-totals__discount">
                            <b-form-select
                              v-if="getValueDiscount && getValueDiscount.length"
                              v-model="crud.form.percentage_discount"
                              :options="getValueDiscount"
                              size="sm"
                              @input="validDiscounts()">
                            </b-form-select>
                            <b-form-input
                              v-if="!getValueDiscount || !getValueDiscount.length"
                              v-model="crud.form.percentage_discount"
                              type="number"
                              min="0"
                              max="100"
                              step="1"
                              size="sm"
                              @change="validDiscounts()"/>
                            <span class="crud-orders-totals__discount-suffix">%</span>
                          </div>
                          <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(crud.form.discounts_price)}}</span>
                        </div>
                      </div>
                      <div class="crud-orders-totals__row crud-orders-totals__row--total">
                        <span class="crud-orders-totals__label">Total s/IVA</span>
                        <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getTotalOrder)}}</span>
                      </div>
                      <div class="crud-orders-totals__row">
                        <span class="crud-orders-totals__label">Total c/IVA</span>
                        <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getTotalOrderWithIva())}}</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>

            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Observaciones" icon="fa fa-flag-checkered">
          <b-row>
            <b-col md="6">

              <div v-if="crud.form.customers">
                <b-avatar :src="crud.form.customers.image"
                          v-if="crud.form.customers.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(crud.form.customers.name).text"
                          :style="avatarFromName(crud.form.customers.name).style">
                </b-avatar>
                &nbsp;<b>{{crud.form.customers.name}}</b>

                <span v-if="crud.form.customers.bcra_status">
                  <span v-if="crud.form.customers.bcra_status.situacion > situationCreditMax">
                    &nbsp;
                    <b-badge variant="danger" :id="'popover-situation-' + crud.form.id">
                      Sit {{crud.form.customers.bcra_status.situacion}}
                    </b-badge>
                    <b-popover :target="'popover-situation-' + crud.form.id" variant="danger" triggers="hover">
                      <template #title>Riesgo Creditício</template>
                      <div v-html="situationCreditMessage(crud.form)"></div>
                    </b-popover>
                  </span>
                </span>

                <AppIcon name="circle-fill" v-if="!crud.form.customers.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />

                <div v-if="crud.form.customers" class="ml-3">
                  <div v-if="!crud.form.customers.email">
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                  </div>
                  <div v-else>
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-link :href="'mailto:' + crud.form.customers.email">
                      {{ crud.form.customers.email }}
                    </b-link>
                  </div>
                </div>

                <div v-if="crud.form.customers.phone" class="ml-3">
                  <AppIcon name="call" /> &nbsp;&nbsp;
                  <b-link :href="'tel:' + crud.form.customers.phone">
                    {{ crud.form.customers.phone }}
                  </b-link>
                </div>

                <b-row v-if="crud.form.customers.observations || crud.form.customers.observations_delivery || crud.form.customers.observations_delivery_address">
                  <b-col>
                    <hr>
                  </b-col>
                </b-row>

                <b-row v-if="crud.form.customers.observations"  class="mt-2">
                  <b-col class="crud-orders-observations">
                    <b>Observaciones</b>
                    <br>
                    {{ crud.form.customers.observations }}
                  </b-col>
                </b-row>
                <b-row v-if="crud.form.customers.observations_delivery"  class="mt-2">
                  <b-col class="crud-orders-observations">
                    <b>Transporte</b>
                    <br>
                    {{ crud.form.customers.observations_delivery }}
                  </b-col>
                </b-row>
                <b-row v-if="crud.form.customers.observations_delivery_address" class="mt-2">
                  <b-col class="crud-orders-observations">
                    <b>Dirección de Entrega</b>
                    <br>
                    {{ crud.form.customers.observations_delivery_address }}
                  </b-col>
                </b-row>
              </div>

              <b-row v-if="!crud.form.id">
                <b-col md="12">
                  <hr class="mt-2 mb-2">
                </b-col>
                <b-col md="12">
                  <b-form-checkbox v-model="crud.form.send_notification_email_customer" switch class="mt-2 mb-4">
                    Enviar notificación por email al cliente
                  </b-form-checkbox>
                </b-col>
                <b-col md="12" v-if="crud.form.send_notification_email_customer">
                  <b-form-group label="Email Alternativo" description="Este email se agrega a la lista de receptores del cliente para este pedido">
                    <b-form-input type="text"
                                  size="sm"
                                  v-model="crud.form.email_alternative"
                                  lazy
                                  required
                                  placeholder="Ingresar un email alternativo">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="6">
              <b-row>
                <b-col md="12">
                  <b-form-group label="Observaciones">
                    <app-textarea
                      v-model="crud.form.observations"
                      placeholder="Ingresar las observaciones..."
                      rows="5"
                      max-rows="7"
                      lazy
                    ></app-textarea>
                  </b-form-group>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-form-group label="Observaciones Internas (No se muestra al cliente)">
                    <app-textarea
                      v-model="crud.form.observations_internal"
                      placeholder="Ingresar las observaciones internas..."
                      rows="5"
                      max-rows="7"
                      lazy
                    ></app-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>

      </form-wizard>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Detail from '@/components/inc/cpbtDetail/detailProducts'
  import Param from '@/config/parameters'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Function from '@/handler/funciones'

  export default {
    name: 'OrderFormModal',
    components: {
      FindObject,
      Detail,
      FormWizard,
      TabContent,
    },
    data: () => {
      return {
        parameters: {
          multipleItems: Helper.hasParametersAccess(Param.P52),
          haveReason: Helper.hasParametersAccess(Param.P54),
        },
        crud: {
          form: {
            id: 0,
            date: '',
            observations: '',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            observations_internal: '',
            erp_points_sales_id: 0,
            erp_points_sales: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            methods_payment_id: 0,
            methods_payment: null,
            detail: [],
            email_alternative: '',
            shipping_id: 0,
            shipping: null,
            discounts_price: 0,
            percentage_discount: 0,
            is_retail: false,
            send_notification_email_customer: true,
            reason: null,
            reason_id : 0,
          },
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
        },
        itemDetailForceUpdate: 0,
      }
    },
    mounted() {
      this.loadConfigurations()
      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.loadConfigurations()
    },
    computed: {
      situationCreditMax() {
        if(this.configurations) {
          return this.configurations[1].value_number;
        } else {
          return 0;
        }
      },

      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive(){
        return [{field: 'active', condition: true}];
      },
      conditionSuppliersShippingActive(){
        var condition = []
        condition.push({field: 'active', condition: true})
        condition.push({field: 'shipping', condition: true})
        return condition;
      },
      conditionReason() {
        let condition = []
        if(this.crud.form.customers_id) {
          condition.push({field: 'customer', condition: this.crud.form.customers_id});
        }
        return condition
      },

      getTagDiscount() {
        if(this.configurations && this.configurations[19].value_string) {
          return this.configurations[19].value_string
        } else {
          return 'Descuento'
        }
      },
      getValueDiscount(){
        if(this.configurations && this.configurations[20].value_string) {
          var value = JSON.parse(this.configurations[20].value_string)
          var arr = []
          value.forEach(element => {
            arr.push({
              value:element,
              text: element + ' %'
            })
          });
          return arr
        } else {
          return null
        }
      },
      getAplicationDiscount() {
        if(this.configurations) {
          if(this.configurations[21].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },

      validStock() {
        if(this.configurations) {
          if(this.configurations[2].value_boolean == 1) {
            return false
          } else {
            return true
          }
        } else {
          return true;
        }
      },
      editPrice() {
        if(this.configurations) {
          if(this.configurations[3].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      allowProductsDuplicates() {
        if(this.configurations) {
          if(this.configurations[16].value_boolean == 1) {
            return true
          } else {
            if(this.parameters.multipleItems) {
              return true
            } else {
              return false
            }
          }
        } else {
          if(this.parameters.multipleItems) {
            return true
          } else {
            return false
          }
        }
      },
      showItemOnlyPublished() {
        var status = this.crud.form.reason && this.crud.form.reason.only_published
        return status
      },

      getSubTotalOrder() {
        var price = 0
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {
            price = price + parseFloat(element.quantity) * parseFloat(element.amount)
          })
        }
        return parseFloat(price)
      },
      getTotalOrder() {
        if(this.getAplicationDiscount) {
          return this.getSubTotalOrder
        } else {
          this.validDiscounts()
          var discounts_price = parseFloat(this.crud.form.discounts_price)

          return this.getSubTotalOrder - discounts_price
        }
      },
      getCantItemOrder() {
        var cant = this.crud.form.detail.length
        return parseFloat(cant)
      },
      getCurrencyOrder() {
        var currency = 'ARS'
        if(this.crud.form.price_list) {
          if(this.crud.form.price_list.currency) {
            currency = this.crud.form.price_list.currency.code
          }
        }
        return currency
      },

      // VALIDA TRANSPORTE
      showShipping() {
        if(this.configurations) {
          if(this.configurations[18].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      validShipping() {
        if(this.configurations) {
          if(this.configurations[17].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
    },
    methods: {
      getOrderLineTotalWithIva(item) {
        const detail = this.$refs.orderDetail
        let aliquot = 0
        if(detail && detail.getDetailItemAliquotIva) {
          aliquot = parseFloat(detail.getDetailItemAliquotIva(item)) || 0
        } else if(item && item.product && item.product.amount) {
          aliquot = parseFloat(item.product.amount.aliquot_iva) || 0
        }
        const amount = parseFloat(item.amount) || 0
        const quantity = parseFloat(item.quantity) || 0
        if(Helper.hasParametersAccess(Param.P75)) {
          const unitCents = Math.round(amount * (1 + aliquot / 100) * 100)
          return Math.round(unitCents * (Math.round(quantity * 100) / 100)) / 100
        }
        return quantity * amount * (1 + aliquot / 100)
      },
      getTotalOrderWithIva() {
        let total = 0
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {
            total = total + this.getOrderLineTotalWithIva(element)
          })
        }
        // El descuento general baja el neto; el IVA baja en la misma proporción.
        const subtotal = this.getSubTotalOrder
        if(!this.getAplicationDiscount && subtotal > 0) {
          const discount = parseFloat(this.crud.form.discounts_price) || 0
          total = total * ((subtotal - discount) / subtotal)
        }
        return total
      },

      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data
          this.configurations = data
        })
      },

      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(!this.crud.form.observations && !this.crud.form.id) {
            if(object.observations_delivery_address) {
              this.crud.form.observations = 'ENTREGA: ' + object.observations_delivery_address
            }
          }

          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.erp_points_sales_id) {
                this.crud.form.erp_points_sales = object.data_fiscal.points_sales
                this.crud.form.erp_points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id
              }
            }

            if(object.data_fiscal.shipping_id) {
              if(!this.crud.form.shipping_id) {
                this.crud.form.shipping = object.data_fiscal.shipping
                this.crud.form.shipping_id = object.data_fiscal.shipping_id
              }
            }
          }

          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }
          }

          if(this.parameters.haveReason) {
            this.crud.form.reason = null
            this.crud.form.reason_id = 0
          }
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.erp_points_sales = object
          this.crud.form.erp_points_sales_id = object.id
        } else {
          this.crud.form.erp_points_sales = null
          this.crud.form.erp_points_sales_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }

        this.detailForceUpdate()
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadShipping (object) {
        if(object){
          this.crud.form.shipping = object
          this.crud.form.shipping_id = object.id
        } else {
          this.crud.form.shipping = null
          this.crud.form.shipping_id = 0
        }
      },
      loadReason (object) {
        if(object){
          this.crud.form.reason = object
          this.crud.form.reason_id = object.id

          if(object && object.price_list_id && object.list) {
            this.crud.form.price_list = object.list
            this.crud.form.price_list_id = object.list.id
            this.crud.form.disable_customer_price_list_fallback = false
          } else {
            if(!this.crud.form.disable_customer_price_list_fallback &&
               this.crud.form.customers &&
               this.crud.form.customers.price_list &&
               this.crud.form.customers.price_list.list) {
              this.crud.form.price_list = this.crud.form.customers.price_list.list
              this.crud.form.price_list_id = this.crud.form.customers.price_list.list.id
              this.crud.form.disable_customer_price_list_fallback = false
            }
          }
        } else {
          this.crud.form.reason = null
          this.crud.form.reason_id = 0
        }

        this.detailForceUpdate()
      },

      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },

      // CRUD MAIN
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.observations_internal = ''
        this.crud.form.erp_points_sales_id = 0
        this.crud.form.erp_points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.disable_customer_price_list_fallback = false
        this.crud.form.detail = []
        this.crud.form.email_alternative = ''
        this.crud.form.shipping_id = 0
        this.crud.form.shipping = null
        this.crud.form.discounts_price = 0
        this.crud.form.percentage_discount = 0
        this.crud.form.is_retail = false
        this.crud.form.send_notification_email_customer = true
        this.crud.form.reason_id = 0
        this.crud.form.reason = null

        this.detailForceUpdate()

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Pedido"
        this.modal.form.active = true
      },
      edit(item) {
        let loader = this.$loading.show();

        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.observations = item.observation
        this.crud.form.staff_id = (item.staff_id) ? item.staff_id : Helper.getStaffId()
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.observations_internal = item.observations_internal
        this.crud.form.erp_points_sales_id = item.erp_points_sales_id
        this.crud.form.erp_points_sales = item.points_sales
        this.crud.form.methods_payment_id = item.methods_payment_id
        this.crud.form.methods_payment = item.method_payment
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.disable_customer_price_list_fallback = !item.price_list_id
        this.crud.form.email_alternative = item.email_alternative
        this.crud.form.shipping_id = item.shipping_id
        this.crud.form.shipping = item.shipping
        this.crud.form.discounts_price = parseFloat(item.discounts_price)
        this.crud.form.percentage_discount = parseFloat(item.percentage_discount)
        this.crud.form.is_retail = item.is_retail
        this.crud.form.send_notification_email_customer = true
        this.crud.form.reason_id = item.reason_id
        this.crud.form.reason = item.reason

        this.detailForceUpdate()

        var result = serviceAPI.mostrarPedido(item.id);

        result.then((response) => {
          var data = response.data
          this.crud.form.detail = data.detail

          // recalculo el % si no se guardo
          if(parseFloat(item.discounts_price) && !parseFloat(item.percentage_discount)) {
            this.crud.form.percentage_discount = this.getSubTotalOrder / item.discounts_price
          }

          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = 'PEDIDO ' + this.crud.form.erp_points_sales.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.id.toString().padStart(8,'0')
          this.modal.form.active = true
          loader.hide()
        })
        .catch(error => {
          // Una demora/error del detalle no debe dejar la vista bloqueada con el loader.
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      save() {
        if(!this.crud.form.erp_points_sales_id) {
          this.$awn.alert('Falta cargar el punto de venta')
          return false
        }

        this.confirmDialog('¿Desea continuar con la generación del pedido?', {
          title: 'Generar Pedido',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            if (this.crud.form.id) {
              var result = serviceAPI.editarPedido(this.crud.form);
            } else {
              var result = serviceAPI.agregarPedido(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.$emit('saved', response)
              this.$awn.success("Pedido generado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el pedido?', {
          title: 'Cancelar el Pedido',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      orderValidDetailGeneral() {
        var valid = this.crud.form.customers_id && this.crud.form.erp_points_sales_id && this.crud.form.methods_payment_id

        if(this.validShipping) {
          valid = valid && this.crud.form.shipping_id
        }

        if(this.parameters.haveReason) {
          valid = valid && this.crud.form.reason_id
        }

        if(valid) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.erp_points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
          if(!this.crud.form.methods_payment_id) {
            this.$awn.alert("No se cargó la condición de pago");
            return false;
          }
          if(this.validShipping) {
            if(!this.crud.form.shipping_id) {
              this.$awn.alert("No se cargó el transporte");
              return false;
            }
          }
          if(this.parameters.haveReason) {
            if(!this.crud.form.reason_id) {
              this.$awn.alert("No se cargó el motivo");
              return false;
            }
          }
        }
      },
      orderValidDetailItems() {
        if(this.crud.form.detail.length) {
          return true;
        } else {
          this.$awn.alert("No se cargó ningún item");
          return false;
        }
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },

      // DISCOUNTS
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }

        var percentage = parseFloat(this.crud.form.percentage_discount)
        this.crud.form.discounts_price = (this.getSubTotalOrder * percentage) / 100
      },

      situationCreditMessage(item) {
        if(item.customer) {
          var message = "<b>Fecha:</b> "+ moment(item.customer.bcra_status.fecha).format('DD/MM/YYYY') +"<br><b>Situación:</b> "+ item.customer.bcra_status.situacion +"<br><b>Cheques Rechazados:</b> " + item.customer.bcra_status.rechazos
          return message;
        } else {
          return '';
        }
      },
    }
  }
</script>
<style>
  .crud-orders-wizard .wizard-header {
    padding: 0px;
  }
  .crud-orders-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-left,
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-orders-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before,
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-orders-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-orders-wizard .wizard-footer-left,
    .crud-orders-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-orders-wizard .wizard-footer-left > span,
    .crud-orders-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-orders-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-orders-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-orders-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-orders-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-orders-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-orders-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-orders-totals__row + .crud-orders-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-orders-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-orders-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-orders-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-orders-totals__row--total .crud-orders-totals__label,
  .crud-orders-totals__row--total .crud-orders-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-orders-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-orders-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-orders-totals__discount input,
  .crud-orders-totals__discount select {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-orders-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .orders-form-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
</style>
<style scoped>
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .crud-orders-observations {
    overflow: auto;
    max-height: 70px;
    font-size: 12px;
  }
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
